import React from 'react';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-gradient-to-r from-slate-900 to-slate-800 text-white p-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-white text-sky-600 font-bold rounded flex items-center justify-center">V</div>
          <div>
            <div className="text-lg font-semibold">Vortex</div>
            <div className="text-xs opacity-80">Thales GenTech 2025 — AI · Simulation</div>
          </div>
        </div>
        <div>
          <button id="open-sim" className="bg-sky-500 hover:bg-sky-600 text-white px-3 py-1 rounded">Open Simulation</button>
        </div>
      </header>

      <main className="flex flex-1">
        <aside className="w-96 p-6 bg-white shadow">
          <h2 className="text-xl font-semibold mb-2">About</h2>
          <p className="mb-4 text-sm">Vortex is an interactive pandemic spread simulation augmented with an AI assistant to analyze scenarios and suggest mitigation strategies. This entry targets the AI-Powered Solutions theme with applicability to Defence &amp; Security and Aeronautics &amp; Space via risk analysis.</p>

          <h3 className="text-lg font-medium">AI Assistant</h3>
          <label className="block text-sm mt-2">Ask Vortex</label>
          <textarea id="ai-prompt" rows="4" className="w-full border p-2 rounded mt-1" placeholder='e.g. "How to reduce infection spread by 30%?"'></textarea>
          <div className="flex gap-2 mt-2">
            <button id="ai-send" className="bg-sky-600 text-white px-3 py-1 rounded">Send</button>
            <button id="ai-clear" className="px-3 py-1 border rounded">Clear</button>
          </div>

          <h4 className="mt-4 text-sm font-medium">AI Response</h4>
          <div id="ai-result" className="mt-2 bg-gray-50 p-3 rounded text-sm">No response yet</div>

          <div className="mt-6 text-xs text-gray-600">
            <p>Team: <strong>Vortex</strong></p>
            <p>Theme: <strong>AI-Powered Solutions</strong></p>
            <p>Impact areas: Defence & Security | Aeronautics & Space | Cybersecurity</p>
          </div>
        </aside>

        <section id="three-root" className="flex-1 relative bg-white">
          <div className="absolute top-4 left-4 z-50 bg-white p-2 rounded shadow">
            <div className="text-sm">Total confirmed cases: <span className="case-counter text-red-600">0</span></div>
            <div className="text-sm">Total days elapsed: <span className="day-counter">0</span></div>
          </div>
          {/* Three.js canvas will be appended into this container by the existing renderer logic */}
        </section>
      </main>

      <footer className="text-center text-xs text-gray-500 p-3">Vortex — Thales GenTech India Hackathon 2025</footer>
    </div>
  );
}
